import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
// import clearProps from '../../utils/clearProps'

const configs = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'onlyChild'
  ],
  modifiers: [],
  states: []
}

export default function Accordion(props) {
  const { config, onOpen, onClick, data, dataAccordion, ...rest } = props

  const [state, setState] = React.useState({
    data: data || dataAccordion,
    currentOpenedIndex: null
  })

  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      data: props.data.map((item, idx) => {
        if (idx === prev.currentOpenedIndex) {
          return {
            ...item,
            isOpen: prev.data[idx].isOpen
          }
        } else {
          return {
            ...item
          }
        }
      })
    }))
  }, [props.data, state.currentOpenedIndex])

  const handleKeyPress = (e, index) => {
    if (e.charCode === 32 || e.charCode === 13) {
      handleBoxClick(e, index)
    }
  }

  const handleBoxClick = (e, index) => {
    const { data } = state
    const onOpen = config?.onOpen
    const onClose = config?.onClose
    const currentOpenedIndex = state.currentOpenedIndex

    if (
      currentOpenedIndex !== null &&
      currentOpenedIndex >= 0 &&
      currentOpenedIndex !== index
    ) {
      data[currentOpenedIndex].isOpen = false
      onClose && onClose(e, currentOpenedIndex)
    }

    const isOpen = !data[index].isOpen
    data[index].isOpen = isOpen
    // eslint-disable-next-line object-curly-spacing
    setState({ ...state, currentOpenedIndex: index })

    isOpen && onOpen && onOpen(e, index)
    !isOpen && onClose && onClose(e, index)
  }

  const renderAccordion = (dataAccordion) => {
    return dataAccordion?.map((item, index) => {
      const { gtmClassName = '', dataGTM = {} } = item

      return (
        <div
          key={index}
          aria-label="Acordion clicável para expandir o conteúdo"
          tabIndex={0}
          onKeyPress={(e) => handleKeyPress(e, index)}
          className={`mdn-Accordion-box  ${item.isOpen ? ' is-expanded' : ''} `}
        >
          <a
            className={`mdn-Accordion-toggle mdn-Text mdn-Text--body ${gtmClassName}`}
            role="button"
            aria-controls={`content-${index}`}
            {...dataGTM}
            onClick={(e) => {
              handleBoxClick(e, index)
            }}
            {...item.props}
          >
            {item.title}
            <span className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg" />
          </a>
          <div className="mdn-Accordion-content">{item.content}</div>
        </div>

      )
    })
  }

  return (
    <div
      {...rest}
      className={resolveProps(props, configs, 'Accordion')}
      aria-label="Accordion Control Group"
    >
      {renderAccordion(state.data)}
    </div>
  )
}

Accordion.propTypes = {
  config: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.content
    }),
    onOpen: PropTypes.func,
    onClose: PropTypes.func
  }),
  data: PropTypes.arrayOf(PropTypes.object),
  dataAccordion: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.content
  }),
  className: PropTypes.string
}
